function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useState, useEffect } from 'react';
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
const affiliatedCompaniesService = {
  useAffiliatedCompanies(elsterId) {
    const [affiliatedCompanies, setAffiliatedCompanies] = useState(null);
    const fetchAffiliatedCompanies = useErrorHandling(useCallback(async () => {
      const affiliatedCompanies = await affiliatedCompaniesService.all(elsterId);
      setAffiliatedCompanies(affiliatedCompanies);
    }, [elsterId]));
    useEffect(() => {
      fetchAffiliatedCompanies();
    }, [fetchAffiliatedCompanies]);
    return [affiliatedCompanies, setAffiliatedCompanies];
  },
  useSaveAffiliatedCompany(elsterId, setAffiliatedCompanies, setSelectedAffiliatedCompany) {
    return useErrorHandling(useCallback(async (affiliatedCompany, affiliatedCompanies) => {
      if (affiliatedCompany.id) {
        const updatedAffiliatedCompany = await affiliatedCompaniesService.update(elsterId, affiliatedCompany);
        const newAffiliatedCompanies = [...affiliatedCompanies];
        const index = newAffiliatedCompanies.findIndex(ac => ac.id === updatedAffiliatedCompany.id);
        newAffiliatedCompanies[index] = updatedAffiliatedCompany;
        setAffiliatedCompanies(newAffiliatedCompanies);
        setSelectedAffiliatedCompany(null);
      } else {
        const newAffiliatedCompany = await affiliatedCompaniesService.create(elsterId, affiliatedCompany);
        setAffiliatedCompanies([...affiliatedCompanies, newAffiliatedCompany]);
        setSelectedAffiliatedCompany(null);
      }
    }, [elsterId, setAffiliatedCompanies, setSelectedAffiliatedCompany]));
  },
  create(elsterId, affiliated_company) {
    return fetch("/api/elsters/".concat(elsterId, "/affiliated_companies/"), _objectSpread(_objectSpread({}, request.post), {}, {
      body: JSON.stringify({
        affiliated_company
      })
    }));
  },
  update(elsterId, affiliated_company) {
    return fetch("/api/elsters/".concat(elsterId, "/affiliated_companies/").concat(affiliated_company.id), _objectSpread(_objectSpread({}, request.put), {}, {
      body: JSON.stringify({
        affiliated_company
      })
    }));
  },
  all(elsterId) {
    return fetch("/api/elsters/".concat(elsterId, "/affiliated_companies/"), _objectSpread({}, request.get));
  },
  delete(elsterId, affiliated_company_id) {
    return fetch("/api/elsters/".concat(elsterId, "/affiliated_companies/").concat(affiliated_company_id), _objectSpread({}, request.delete));
  }
};
export default affiliatedCompaniesService;